import React, { useEffect } from 'react';
import './psatencionjuv2024.css';
import { psatencionjuv2024 } from '../../json/psatencionjuv2024';

const Psatencionjuv2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Atención a la Juventud 2024"</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
              
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                Que el Programa Atención a la Juventud se enfoca a contribuir a la mejora de la calidad de vida de las y los jóvenes, implementando políticas que alcancen a satisfacer las necesidades más sentidas en temas como educación, desarrollo integral y emprendimiento; buscando que los jóvenes puedan ser partícipes del desarrollo de sus comunidades y del estado. El Programa asume el cambio institucional y de políticas públicas desde la perspectiva de infancia y adolescencia al considerar la observancia de los objetivos nacionales para promover y garantizar los derechos de las Niñas, Niños y Adolescentes, que se corresponden con los Objetivos de Desarrollo Sostenible de la Agenda 2030, a fin de dar cumplimiento a lo que establece la Ley General en la materia, a los tratados internacionales de los que el Estado Mexicano es parte, e impactar positivamente las condiciones y calidad de vida de la Niñas, Niños y Adolescentes, reducir las brechas de desigualdad; prevenir y reducir la violencia; así como combatir el trabajo infantil y la discriminación.
                </h6><br />
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir al desarrollo integral de la juventud hidalguense, mediante las intervenciones y acciones en materia de salud, empleo y participación juvenil, a fin de mejorar la calidad de vida de las y los jóvenes.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Jóvenes hidalguenses con edad comprendida entre los 12 a 29 años, dando cobertura a los 84 municipios del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                Estatal
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)'  }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Dirección General del <a
                href='https://juventud.hidalgo.gob.mx/'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Instituto Hidalguense de la Juventud</a>
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Luis Ricardo Olvera Molina<br />                    
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                771 719 32 93 y 771 719 32 92
                          

                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong>Reglas de Operación</strong></h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Instituto_Hidalguense_de_la_Juventud.pdf%22'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's</a>
                </li>
                <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Juventud_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Reforma 02 de febrero de 2024</a><br />
                  </li>
                  </ul>
                <p>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psatencionjuv2024;